import CONSTANTS from 'utils/systemsConstants'

const { CONCORRENCIA } = CONSTANTS

const isConcurrenceProperty = tags => tags.includes(CONCORRENCIA)

export default isConcurrenceProperty
